'use strict';

// prevent error on handlebars with webpack
const Hdl = require(__dirname + '/../../node_modules/handlebars/runtime');

const _ = require('lodash');
const translator = require('./../core/translator');

Hdl.registerHelper('trans', function(key, params) {
    return translator.translate(key, params);
});

Hdl.registerHelper('concat', function(...args) {
    let text = '';

    _.each(args, function(str) {
        if (_.isString(str)) {
            text = text + str;
        }
    });

    return text;
});

Hdl.registerHelper('ifCond', function(v1, v2, options) {
  if(v1 === v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

module.exports = Hdl;
